###
Shared header height computed props
###
import dimensions from 'library/styles/vars/dimensions'

displayTabs = [
	'brand'
	'kitchen'
	'select'
]

addPixels = (...pixels) ->
	total = pixels.reduce (a, b) ->
		parseInt(a, 10) + parseInt(b, 10)
	, 0

	return "#{total}px"

export default

	computed:
		showBanner: -> @$store.getters['globals/showBanner']

		showTabs: -> @currentSite in displayTabs

		currentSite: -> process.env.CMS_SITE

		tabsHeight: -> if @showTabs then dimensions['tabs-h'] else '0px'
		tabsHeightMobile: -> if @showTabs then dimensions['tabs-h-mobile'] else '0px'


		headerHeight: ->
			if @showBanner
				addPixels dimensions['header-h'], @tabsHeight
			else
				addPixels dimensions['nav-h'], @tabsHeight

		mobileHeaderHeight: ->
			if @showBanner
				addPixels dimensions['header-h-mobile'], @tabsHeightMobile
			else
				addPixels dimensions['nav-h-mobile'], @tabsHeightMobile

		bannerHeight: ->
			if @showBanner
				dimensions['header-h']

		bannerHeightMobile: ->
			if @showBanner
				dimensions['header-h-mobile']

		parsedHeaderHeight: -> parseInt @headerHeight

		parsedMobileHeaderHeight: -> parseInt @mobileHeaderHeight
